var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04257 15.127L15.6134 5.55563C15.9916 5.1938 16.4963 4.9944 17.0196 5.00012C17.543 5.00584 18.0432 5.21623 18.4134 5.58623C18.7835 5.95624 18.994 6.45645 18.9999 6.97975C19.0057 7.50306 18.8065 8.00786 18.4447 8.38607L8.8723 17.9575C8.65393 18.1758 8.37581 18.3247 8.07297 18.3853L5 19L5.61475 15.9263C5.67532 15.6235 5.82419 15.3454 6.04257 15.127Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8L16 10",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgEdit;